var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailfacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-svgrepo-com_4_",
    "data-name": "facebook-svgrepo-com (4)",
    transform: "translate(143 -145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34435",
    "data-name": "Path 34435",
    d: "M-131,145a12,12,0,0,0-12,12,12,12,0,0,0,12,12,12,12,0,0,0,12-12A12,12,0,0,0-131,145Zm7.491,19.486a10.479,10.479,0,0,1-3.366,2.269,10.493,10.493,0,0,1-4.125.83,10.612,10.612,0,0,1-4.125-.83,10.58,10.58,0,0,1-3.366-2.269,10.479,10.479,0,0,1-2.269-3.366,10.492,10.492,0,0,1-.834-4.12,10.611,10.611,0,0,1,.83-4.125,10.58,10.58,0,0,1,2.269-3.366,10.64,10.64,0,0,1,3.37-2.273,10.611,10.611,0,0,1,4.125-.83,10.611,10.611,0,0,1,4.125.83,10.579,10.579,0,0,1,3.366,2.269,10.478,10.478,0,0,1,2.269,3.366,10.493,10.493,0,0,1,.83,4.125,10.611,10.611,0,0,1-.83,4.125A10.58,10.58,0,0,1-123.509,164.486Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34436",
    "data-name": "Path 34436",
    d: "M55.482,274.9a3.666,3.666,0,0,1,.954.157l.3-1.919a6.776,6.776,0,0,0-2.123-.235,2.052,2.052,0,0,0-1.841.945,3.658,3.658,0,0,0-.381,1.944v1.258H51.2v1.875h1.187v6.512h2.222v-6.512h1.76l.13-1.875h-1.89v-1.464C54.608,275.079,55.02,274.9,55.482,274.9Z",
    transform: "translate(-184.968 -122.172)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailfacebook);
export default __webpack_public_path__ + "static/media/emailfacebook.73185eee5e0c42a13dcd77b584a232df.svg";
export { ForwardRef as ReactComponent };